export function formatBytes(
  bytes: number,
  decimals = 2
): { value: number; postfix: string } {
  if (!bytes) {
    return {
      value: 0,
      postfix: 'байт',
    }
  }

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals

  const sizes = ['байт', 'Кб', 'Мб', 'Гб', 'Тб']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return {
    value: parseFloat((bytes / Math.pow(k, i)).toFixed(dm)),
    postfix: sizes[i],
  }
}

export function transformBytes(bytes: number, decimals = 2): string {
  const value = formatBytes(bytes, decimals)
  return `${value.value} ${value.postfix}`
}
